/* eslint-disable no-param-reassign */
import { setIn } from 'final-form';

const validate = async (values, schema, context) => {
  if (typeof schema === 'function') {
    schema = schema();
  }

  try {
    await schema.validate(values, { abortEarly: false, context });
  } catch (e) {
    return e.inner.reduce((errors, error) => {
      return setIn(errors, error.path, error.message);
    }, {});
  }

  return null;
};

export default validate;
